/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */

import { find } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Img from '../../Img';
import PopOverMenu from '../../PopOverMenu';
import { isNewRosterModelEnabled } from '../../../utils/statsig';

const _ = { find };

class SchoolCard extends Component {
    getPower6(isMixedClubSubType, power6Men, power6Women, power6) {
        if (isMixedClubSubType) {
            if (!power6Men && !power6Women) { return '0'; }
            const menValue = power6Men ? power6Men.toFixed(2) : 0;
            const womenValue = power6Women ? power6Women.toFixed(2) : 0;
            return `${menValue}B, ${womenValue}G`;
        }
        return power6 ? power6.toFixed(2) : '0';
    }

    getPower6Roster(roster) {
        return roster?.power6?.power6Rating ? roster?.power6.power6Rating.toFixed(2) : '0';
    }

    getPower6Value(isNewRosterModel, activeRoster, isMixedClubSubType, power6Men, power6Women, power6) {
        if (isNewRosterModel) {
            return this.getPower6Roster(activeRoster);
        }
        return this.getPower6(isMixedClubSubType, power6Men, power6Women, power6);
    }

    render() {
        const { force = {}, forceCardView, isPowerUser, menuOptions, menuOnSelected, rank, clubSubTypes, savedList, checkGate, featureGates, 'data-testid': dataTestId } = this.props;
        const { name, location, school, clubProfileImages, gender, isCollege, isHighSchool, clubSubTypeId, activeRoster } = this.props.schoolClub;
        const { conference, power6, power6Men, power6Women, displayName, shortName } = school || {};
        const photoUrl = clubProfileImages?.default ? `/v1/club/${clubProfileImages.default}?variant=icon` : null;
        const locationValue = location?.display ?? '';
        const descriptionItems = [locationValue];
        const currentClubSubType = _.find(clubSubTypes, subType => subType.id === clubSubTypeId);
        const isMixedClubSubType = clubSubTypeId === 3;

        const isNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, isCollege);
        const power6Value = this.getPower6Value(isNewRosterModel, activeRoster, isMixedClubSubType, power6Men, power6Women, power6);

        let defaultImage = '/img/v2/icons/icon-avatar-club.svg';
        if (gender && clubSubTypes) {
            if (isCollege) {
                defaultImage = '/img/v2/icons/icon-avatar-college.svg';
                descriptionItems.unshift(currentClubSubType.label);
            } else if (isHighSchool) {
                defaultImage = '/img/v2/icons/icon-avatar-school.svg';
                descriptionItems.unshift(currentClubSubType.description);
            }
        }
        const description = descriptionItems.join(' · ');

        return (
            <div className="utr-card school-card">
                {!savedList ? (
                    <div className={`list-view`}>
                        <div className="d-flex">
                            <div className="flex-grow">
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="name show-ellipsis d-block d-md-none" data-testid={dataTestId && `${dataTestId}.list.mobile.name`}>{name || shortName || displayName}</div>
                                        <div className="name show-ellipsis d-none d-md-block" data-testid={dataTestId && `${dataTestId}.list.desktop.name`}>{name || displayName}</div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="location show-ellipsis" data-testid={dataTestId && `${dataTestId}.list.location`}>{location?.display ?? ''}</div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row w-100">
                                            {isPowerUser && (
                                                <div className={`col-md-4 ${force.collegeDetails ? '' : 'offset-md-8'}`}>
                                                    <div className="values">
                                                        <div className={`value`} data-testid={dataTestId && `${dataTestId}.list.power6-value`}>
                                                            {power6Value}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {force.collegeDetails &&
                                                (
                                                    <>
                                                        <div className="col-md-4">
                                                            <div className="values">
                                                                <div className={`value ellipsis`} title={conference?.division?.divisionName ?? ''} data-testid={dataTestId && `${dataTestId}.list.division`}>
                                                                    {conference?.division?.shortName ?? ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="values">
                                                                <div className={`value ellipsis`} title={conference?.conferenceName ?? ''} data-testid={dataTestId && `${dataTestId}.list.conference`}>
                                                                    {conference?.shortName ?? ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={`list-view ${forceCardView || force.cardView ? 'd-none' : 'd-none d-md-block'}`}>
                        <div className="d-flex">
                            <div className="flex-grow">
                                <div className="row">
                                    <div className="col-md-5">
                                        {!!rank && <div className="rank" data-testid={dataTestId && `${dataTestId}.savedlist.rank`}>{rank}</div>}
                                        <div className="avatar-wrapper">
                                            {photoUrl ? (
                                                <Img
                                                    className="avatar"
                                                    src={photoUrl}
                                                    srcSet={`${photoUrl}&size=1x&type=thumbnail, ${photoUrl}&size=2x&type=thumbnail 2x, ${photoUrl}&size=3x&type=thumbnail 3x`}
                                                    defaultimg={defaultImage}
                                                />
                                            ) : (
                                                <Img className="avatar" src={defaultImage} />
                                            )}
                                        </div>
                                        <div className="name-and-place">
                                            <div className="name show-ellipsis d-block d-md-none" data-testid={dataTestId && `${dataTestId}.savedlist.mobile.name`}>{name || shortName || displayName}</div>
                                            <div className="name show-ellipsis d-none d-md-block" data-testid={dataTestId && `${dataTestId}.savedlist.desktop.name`}>{name || displayName}</div>
                                            <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.savedlist.place`}>{location?.display ?? ''}</div>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="row w-100">
                                            {isPowerUser && (
                                                <div className="col-md-4">
                                                    <div className="values">
                                                        <div className={`value`} data-testid={dataTestId && `${dataTestId}.savedlist.power6-value`}>
                                                            {power6Value}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {force.collegeDetails &&
                                                (
                                                    <>
                                                        <div className="col-md-4">
                                                            <div className="values">
                                                                <div className={`value ellipsis`} title={conference?.division?.divisionName ?? ''} data-testid={dataTestId && `${dataTestId}.savedlist.division`}>
                                                                    {conference?.division?.shortName ?? ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="values">
                                                                <div className={`value ellipsis`} title={conference?.conferenceName ?? ''} data-testid={dataTestId && `${dataTestId}.savedlist.conference`}>
                                                                    {conference?.shortName ?? ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bookmark">
                                {menuOptions && menuOptions.length > 0 && (
                                    <PopOverMenu
                                        horizontalEllipsis={false}
                                        menuItems={menuOptions}
                                        onSelected={menuOnSelected}
                                        data-testid={dataTestId && `${dataTestId}.list.menu`}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                <div className={`card-view ${forceCardView || force.cardView ? 'd-block' : 'd-block d-md-none'}`}>
                    <div className="header d-flex align-items-stretch">
                        <div className="name-wrapper">
                            <div className="name university d-block d-md-none" data-testid={dataTestId && `${dataTestId}.card.mobile.name`}>{!!rank && <span className="rank" data-testid={dataTestId && `${dataTestId}.card.mobile.rank`}>{rank}.&nbsp;</span>}{shortName || displayName || name}</div>
                            <div className="name university d-none d-md-block" data-testid={dataTestId && `${dataTestId}.card.desktop.name`}>{!!rank && <span className="rank" data-testid={dataTestId && `${dataTestId}.card.desktop.rank`}>{rank}.&nbsp;</span>}{displayName || name}</div>
                            <div className="location" data-testid={dataTestId && `${dataTestId}.card.location`}>{description}</div>
                        </div>
                        <div className="profile-pic-wrapper">
                            {photoUrl ? (
                                <Img
                                    className="profile-picture"
                                    src={photoUrl}
                                    srcSet={`${photoUrl}&size=1x&type=thumbnail, ${photoUrl}&size=2x&type=thumbnail 2x, ${photoUrl}&size=3x&type=thumbnail 3x`}
                                    defaultimg={defaultImage}
                                />
                            ) : (
                                <Img className="profile-picture" src={defaultImage} />
                            )}
                        </div>
                    </div>
                    <div className="footer d-flex align-items-stretch">
                        <div className="row-wrapper row">
                            {isPowerUser && (
                                <div className="col-4">
                                    <div className="title" data-testid={dataTestId && `${dataTestId}.card.power6-title`}>P6</div>
                                    <div className="value ellipsis" data-testid={dataTestId && `${dataTestId}.card.power6-value`}>{power6Value}</div>
                                </div>
                            )}
                            {force.collegeDetails && (
                                <div className="col-4">
                                    <div className="title" data-testid={dataTestId && `${dataTestId}.card.division-title`}>Div</div>
                                    <div className="value" title={conference?.division?.divisionName ?? ''} data-testid={dataTestId && `${dataTestId}.card.division-value`}>
                                        {conference?.division?.shortName ?? ''}
                                    </div>
                                </div>
                            )}
                            {force.collegeDetails && (
                                <div className="col-4">
                                    <div className="title" data-testid={dataTestId && `${dataTestId}.card.conference-title`}>Conf</div>
                                    <div className="value" title={conference?.conferenceName ?? ''} data-testid={dataTestId && `${dataTestId}.card.conference-value`}>
                                        {conference?.shortName ?? ''}
                                    </div>
                                </div>
                            )}
                            {!force.collegeDetails && (
                                <div className="col-4">
                                    <div className="title">&nbsp;</div>
                                    <div className="value">&nbsp;</div>
                                </div>
                            )}
                        </div>
                        <div className="menu-wrapper">
                            <div className="menu-inner-container">
                                {menuOptions && menuOptions.length > 0 && (
                                    <PopOverMenu
                                        horizontalEllipsis={true}
                                        menuItems={menuOptions}
                                        onSelected={menuOnSelected}
                                        data-testid={dataTestId && `${dataTestId}.card.menu`}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SchoolCard.propTypes = {
    force: PropTypes.shape({}),
    forceCardView: PropTypes.bool,
    isPowerUser: PropTypes.bool,
    menuOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    menuOnSelected: PropTypes.func.isRequired,
    rank: PropTypes.number,
    clubSubTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    savedList: PropTypes.bool,
    checkGate: PropTypes.func,
    featureGates: PropTypes.objectOf(PropTypes.string),
    'data-testid': PropTypes.string,
};
SchoolCard.defaultProps = {
    force: {},
    forceCardView: false,
    isPowerUser: false,
    rank: null,
    savedList: false,
    checkGate: null,
    featureGates: {},
    'data-testid': null,
};

export default SchoolCard;
